import { ColumnsProps } from "@/components/table";
import Role from "@/types/role";
import { User } from "@/types/user";
import { DeleteOutlined, EditOutlined, LockOutlined } from "@ant-design/icons";
import { Button, Space, Switch, Typography } from "antd";
import { ColumnsType } from "antd/es/table";

type GetColumnsProps = ColumnsProps<User> & {
  changePassword: (user: User) => void;
  onToggleActive: (user: User, checked: boolean) => void;
};

export const getColumns = ({
  filterOptions,
  filterValues,
  getSortOrder,
  onEdit,
  onDelete,
  changePassword,
  onToggleActive,
}: GetColumnsProps): ColumnsType<User> => [
  {
    title: "Username",
    dataIndex: "username",
    key: "username",
    sorter: true,
    sortOrder: getSortOrder?.("username"),
    filters: filterOptions?.username,
    filterSearch: true,
    filteredValue: filterValues?.username || null,
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
    render: (email: string) => email || "-",
    sorter: true,
    sortOrder: getSortOrder?.("email"),
    filters: filterOptions?.email,
    filterSearch: true,
    filteredValue: filterValues?.email || null,
  },
  {
    title: "Roles",
    dataIndex: "roles",
    key: "roles",
    sorter: true,
    sortOrder: getSortOrder?.("roles"),
    render: (roles: Role[]) => (
      <Typography.Text style={{ textTransform: "capitalize" }}>
        {roles.map((role) => role.name).join(", ")}
      </Typography.Text>
    ),
  },
  {
    title: "Active",
    dataIndex: "is_active",
    key: "is_active",
    sorter: true,
    sortOrder: getSortOrder?.("is_active"),
    render: (active: boolean, record: User) => (
      <Switch
        checked={active}
        onChange={(checked) => onToggleActive(record, checked)}
      />
    ),
  },
  {
    title: "Actions",
    key: "actions",
    width: 100,
    render: (_: string, record: User) => (
      <Space>
        <Button
          icon={<EditOutlined />}
          onClick={() => onEdit?.(record)}
          type="link"
        />
        <Button
          icon={<LockOutlined />}
          onClick={() => changePassword?.(record)}
          type="link"
        />
        <Button
          icon={<DeleteOutlined />}
          onClick={() => onDelete?.(record)}
          type="link"
          danger
        />
      </Space>
    ),
    fixed: "right" as const,
  },
];
